import {localiseHostName} from 'utils/host-utils';

let availableLanguages;

try {
  availableLanguages = require('./translations/availableLanguages.json');
} catch (err) {
  availableLanguages = [];
}

export default {
  placeholderImageUrl: localiseHostName(
    'https://res.cloudinary.com/swipe-guide-eu/image/upload/v1490354588/placeholder-image.jpg'
  ),
  availableLanguages,
  allowedPersistentQueryParameters: ['embed', 'isolatedInstruction']
};
